export default __webpack_public_path__ + "static/media/logo.721f12ef.svg";